import { createSvgIcon } from '@mui/material/utils';

/**
 * Custom AI Tutor icon — a rounded-square badge with a bottom-center notch
 * and a 4-pointed sparkle inside, matching the Fullglass AI Tutor brand mark.
 */
const TutorBadgeIcon = createSvgIcon(
  <>
    {/* Rounded square with bottom-center notch (like a pin / speech bubble) */}
    <path d="M20 2H4C2.9 2 2 2.9 2 4v12c0 1.1.9 2 2 2h8l2 4 2-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
    {/* 4-pointed sparkle */}
    <path
      d="M12 6l1 4.3L17 11l-4 .7L12 16l-1-4.3L7 11l4-.7z"
      fill="white"
      opacity="0.95"
    />
  </>,
  'TutorBadge'
);

export default TutorBadgeIcon;
